// Le « Suivi des élèves » du dashboard coach web : une carte par élève avec
// ses quatre indicateurs (voir CarteEleve.js). En fenêtre de navigateur pour
// le chapitre coach (deux élèves, dont un qui décroche), ou une carte seule
// pour la grille du haut de page.
import React from "react";
import Apercu from "./Apercu";
import { FenetreWeb } from "./Cadres";
import CarteEleve from "./CarteEleve";
import { ELEVES } from "./donneesDemo";

const TRIS = ["Nom", "Entraînements", "Séances/sem", "Régularité ▼", "Progression", "Régression", "Dernier entr."];

export default function ApercuEleves({ boucle = false, seule = false, className = "" }) {
	if (seule) {
		const e = ELEVES[0];
		return (
			<Apercu
				boucle={boucle}
				className={className}
				description={`Carte élève du dashboard coach : ${e.nom}, régularité ${e.regularite}, ${e.seances.toFixed(1)} séances par semaine, ${e.progression} % de séries en progression, ${e.regression} % en régression.`}
			>
				<CarteEleve eleve={e} className="gs-ce--pleine" />
			</Apercu>
		);
	}

	const lea = ELEVES[1];
	const thomas = ELEVES[3];
	return (
		<Apercu
			boucle={boucle}
			className={className}
			description={`Suivi des élèves du dashboard coach : ${lea.nom} est régulière et progresse sur ${lea.progression} % de ses séries ; ${thomas.nom} n'est pas venu depuis ${thomas.joursDepuis} jours et sa régularité est tombée à ${thomas.regularite}.`}
		>
			<FenetreWeb>
				<div className="gs-ce-entete">
					<span className="gs-ce-titre">Suivi des élèves</span>
					<span className="gs-ce-tris">
						<span>Trier :</span>
						{TRIS.map((t) => (
							<i key={t} className={t.includes("▼") ? "actif" : ""}>
								{t}
							</i>
						))}
					</span>
				</div>
				<div className="gs-ce-grille">
					<CarteEleve eleve={lea} />
					<CarteEleve eleve={thomas} />
				</div>
			</FenetreWeb>
		</Apercu>
	);
}
